import EditDelivery from './AutoDeliveryDetailsPages/EditDelivery/EditDelivery';

const AutoDeliverySkipPage = () => {
    return <EditDelivery isSkip />;
};

export default AutoDeliverySkipPage;
